import { PatientTypeConstants } from '../types/PatientTypeConstants';

export const PatientActions = {
    register,
    registrationFailiure,
    registrationSuccess,
    updateProfile,
    updateProfileSuccess,
    updateProfileFailiure,
    getAllPatients,
    getAllPatientSuccess,
    getAllPatientFailiure,
    getPatientById,
    getPatientByIdSuccess,
    getPatientByIdFailiure,
    searchPatient,
    searchPatientSuccess,
    searchPatientFailiure,
    searchPatientAppointment,
    searchPatientAppointmentSuccess,
    searchPatientAppointmentFailiure,
    updateRegistrationFlags,
    addNewPatient,
    updateAddressInfo,
    updateInsuranceInfo,
    getActiveAllPatients,
    sendPatientSMS,
    clearAll
};

function register(data) {
    return { type: PatientTypeConstants.REGISTER_PATIENT_REQUEST, data };
}

function registrationFailiure(message) {
    return { type: PatientTypeConstants.REGISTER_PATIENT_FAILURE, message:message };
}

function registrationSuccess(user) {
    return { type: PatientTypeConstants.REGISTER_PATIENT_SUCCESS, user };
}

function updateProfile(data) {
    return { type: PatientTypeConstants.UPDATE_PATIENT_REQUEST, data };
}

function updateProfileSuccess(user) {
    return { type: PatientTypeConstants.UPDATE_PATIENT_SUCCESS, user };
}

function updateAddressInfo(user) {
    return { type: PatientTypeConstants.UPDATE_PATIENT_ADDRESS_REQUEST, user };
}

function updateInsuranceInfo(user) {
    return { type: PatientTypeConstants.UPDATE_PATIENT_INS_INFO_REQUEST, user };
}

function updateProfileFailiure(message) {
    return { type: PatientTypeConstants.UPDATE_PATIENT_FAILURE, message };
}

function getAllPatients() {
    return { type: PatientTypeConstants.GET_ALL_PATIENT_REQUEST };
}

function getAllPatientSuccess(data) {
    return { type: PatientTypeConstants.GET_ALL_PATIENT_SUCCESS,data };
}

function getAllPatientFailiure(message) {
    return { type: PatientTypeConstants.GET_ALL_PATIENT_FAILIURE , message:message };
}

function getPatientById(id){
    return { type: PatientTypeConstants.GET_PATIENT_BY_ID_REQUEST,id };
}
function getPatientByIdSuccess(data){
    return { type: PatientTypeConstants.GET_PATIENT_BY_ID_SUCCESS,data };
}
function getPatientByIdFailiure(message){
    return { type: PatientTypeConstants.GET_PATIENT_BY_ID_FAILIURE, message:message };
}

function addNewPatient(){
    return { type: PatientTypeConstants.ADD_NEW_PATIENT };
}

function searchPatient(data){
    return { type: PatientTypeConstants.SEARCH_PATIENT_REQUEST,data };
}
function searchPatientSuccess(data){
    return { type: PatientTypeConstants.SEARCH_PATIENT_SUCCESS,data };
}
function searchPatientFailiure(message){
    return { type: PatientTypeConstants.SEARCH_PATIENT_FAILIURE, message:message };
}

function searchPatientAppointment(data){
    return { type: PatientTypeConstants.PATIENT_APPOINTMENT_REQUEST,data };
}
function searchPatientAppointmentSuccess(data){
    return { type: PatientTypeConstants.PATIENT_APPOINTMENT_SUCCESS,data };
}
function searchPatientAppointmentFailiure(message){
    return { type: PatientTypeConstants.PATIENT_APPOINTMENT_FAILIURE, message:message };
}
function updateRegistrationFlags(data){
    return { type: PatientTypeConstants.UPDATE_PATIENT_REGISTRATION_FLAG, data: data};
}

function getActiveAllPatients() {
    return { type: PatientTypeConstants.GET_ALL_ACTIVE_PATIENT_REQUEST };
}
function sendPatientSMS(data){
    return { type: PatientTypeConstants.SEND_SMS_TO_PATIENT,data };
}
function clearAll(data){
    return { type: PatientTypeConstants.PATIENT_CLEAR_ALL };
}
